import React, { useEffect, useState } from "react";
import PhoneInput from "react-phone-input-2";
import { useFormContext, Controller } from "react-hook-form";

import InputField from "../../../shared/components/input-field/InputField";
import CustomError from "../../../shared/components/custom-error/CustomError";
import FileUploader from "../../../shared/components/file-uploader/FileUploader";
import { allowedFileTypesForRegistrationCertificate } from "../../../constants";

const EmergencyContactForm = () => {
  const {
    formState: { errors },
    watch,
    control,
    clearErrors,
    setError,
    setValue,
  } = useFormContext();
  const [phoneLength, setPhoneLength] = useState(0);

  // Watch the file input to see its value
  const files = watch("emergencyContactInfo.files");
  const headshotfiles = watch("emergencyContactInfo.headshotfiles");
  const document = watch("document");

  useEffect(() => {
    if (watch("emergencyContactInfo.phoneNumber")) {
      if (
        phoneLength > watch("emergencyContactInfo.phoneNumber")?.length &&
        watch("emergencyContactInfo.phoneNumber")?.length < 15
      ) {
        setError("emergencyContactInfo.phoneNumber", {
          type: "minLength",
          message: "Invalid phone number",
        });
      } else {
        clearErrors("emergencyContactInfo.phoneNumber");
      }
    }

    // eslint-disable-next-line
  }, [watch("emergencyContactInfo.phoneNumber")]);

  return (
    <div className="emergency-contact-information">
      <div className="row">
        <div className="col-12 emergency-contact-information-heading">
          Contact Information and Identification
        </div>
        <div className="col-12 emergency-contact-information-sub-heading">
          Emergency Contact Information
        </div>
        {/* full name input field */}
        <div className="col-12 col-lg-6 pe-xl-4">
          <div className="input-field-wrapper">
            <InputField
              name="emergencyContactInfo.fullName"
              placeHolder="Full Name"
            />
            <CustomError
              errorMessage={errors.emergencyContactInfo?.fullName?.message}
            />
          </div>
        </div>
        {/* phone number input field */}
        <div className="col-12 col-lg-6 ps-xl-4">
          <div className="input-field-wrapper">
            <Controller
              name="emergencyContactInfo.phoneNumber"
              placeHolder="(916) 687-9606"
              rules={{ required: true }}
              render={({ field: { ref, ...field } }) => (
                <PhoneInput
                  placeholder="(916) 687-9606"
                  {...field}
                  inputExtraProps={{
                    ref,
                    required: true,
                    autoFocus: true,
                  }}
                  onChange={(phone, country) => {
                    setValue("emergencyContactInfo.phoneNumber", phone);
                    setPhoneLength(
                      country.format.split("").filter((char) => char === ".")
                        .length
                    );
                  }}
                  country={"us"}
                  masks={{
                    sa: ".. ... ....",
                    tr: "... ... ....",
                    eg: ".. .... ....",
                  }}
                />
              )}
            />
            <CustomError
              errorMessage={errors.emergencyContactInfo?.phoneNumber?.message}
            />
          </div>
        </div>
        {/* upload your photo id field */}
        <div className="col-12 col-lg-6 pe-xl-4">
          <div className="upload-photo-wrapper">
            <div className="upload-photo mb-3">
              Upload your Photo ID: <span>Front and Back</span>
            </div>
            <Controller
              name="emergencyContactInfo.files"
              control={control}
              render={({ field: { onChange } }) => (
                <FileUploader
                  files={files || []}
                  onChange={onChange}
                  handleDelete={(index) => {
                    // Remove file from the array
                    const updatedFiles = [...files];
                    updatedFiles.splice(index, 1);
                    onChange(updatedFiles);
                  }}
                  maxFiles={2}
                />
              )}
            />
            <CustomError
              errorMessage={errors.emergencyContactInfo?.files?.message}
            />
          </div>
        </div>
        {/* upload headshot photo field */}
        <div className="col-12 col-lg-6 ps-xl-4">
          <div className="upload-photo-wrapper">
            <div className="upload-photo mb-3">
              Upload Professional Headshot:
            </div>
            <Controller
              name="emergencyContactInfo.headshotfiles"
              control={control}
              render={({ field: { onChange } }) => (
                <FileUploader
                  files={headshotfiles || []}
                  onChange={onChange}
                  handleDelete={(index) => {
                    // Remove file from the array
                    const updatedFiles = [...headshotfiles];
                    updatedFiles.splice(index, 1);
                    onChange(updatedFiles);
                  }}
                  maxFiles={1}
                />
              )}
            />
            <CustomError
              errorMessage={errors.emergencyContactInfo?.headshotfiles?.message}
            />
          </div>
        </div>
        {/* upload registration certificate field */}
        <div className="col-12 col-lg-6 pe-xl-4">
          <div className="upload-photo-wrapper">
            <div className="upload-photo mb-3">
              Upload Company Registration Certificate:
            </div>
            <Controller
              name="document"
              control={control}
              render={({ field: { onChange } }) => (
                <FileUploader
                  files={document || []}
                  accept={allowedFileTypesForRegistrationCertificate}
                  onChange={onChange}
                  handleDelete={(index) => {
                    // Remove file from the array
                    const updatedFiles = [...document];
                    updatedFiles.splice(index, 1);
                    onChange(updatedFiles);
                  }}
                  maxFiles={1}
                />
              )}
            />
            <CustomError errorMessage={errors?.document?.message} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmergencyContactForm;
